import { defineRouting } from "next-intl/routing";
import { getPublicEnv } from "@/config/get-public-env";
import { locales } from "./locales";

const env = getPublicEnv();

export const routing = defineRouting({
  locales,
  defaultLocale: env.NEXT_PUBLIC_DEFAULT_LOCALE,
  localePrefix: env.NEXT_PUBLIC_LOCALE_PREFIX,
});
